module.exports = __webpack_public_path__ + "img/square.b0a49aae.svg";